// PROTOTYPE — stub data for the Automation v2 management page.
// A list of automations + their past executions + per-step run detail.
// All fake, in-memory. Replaces server calls in the real feature.

export const MOCK_AUTOMATIONS = [
    {
        id: "auto_1",
        name: "לקוח חדש מ-Arbox → צור מתאמן + מייל",
        enabled: true,
        trigger: "Arbox — לקוח חדש",
        steps: 3,
        lastRun: "2026-07-14 09:12",
        runsToday: 4,
    },
    {
        id: "auto_2",
        name: "מתאמן נמחק → מייל פרידה",
        enabled: true,
        trigger: "משתמש נמחק",
        steps: 2,
        lastRun: "2026-07-13 18:40",
        runsToday: 1,
    },
    {
        id: "auto_3",
        name: "סנכרון אנשי קשר מ-Fireberry",
        enabled: false,
        trigger: "Fireberry — איש קשר חדש",
        steps: 2,
        lastRun: "2026-07-10 11:05",
        runsToday: 0,
    },
];

// Executions per automation id. status: SUCCESS | FAILED | RUNNING
export const MOCK_EXECUTIONS = {
    auto_1: [
        {
            id: "exec_101", status: "SUCCESS", startedAt: "2026-07-14 09:12", durationMs: 840,
            trigger: {label: "Arbox — לקוח חדש", data: {"arbox.email": "dana@example.com", "arbox.first_name": "דנה", "arbox.last_name": "כהן"}},
            steps: [
                {label: "צור מתאמן", kind: "CREATE_TRAINEE", status: "SUCCESS",
                 output: {traineeId: 8123, userId: 45011, name: "דנה כהן", email: "dana@example.com", username: "dana@example.com", password: "Xy7kQp2r"}},
                {label: "עיבוד נתונים (מיזוג שם)", kind: "DATA_TRANSFORM", status: "SUCCESS",
                 output: {result: "דנה כהן"}},
                {label: "שלח אימייל", kind: "EMAIL", status: "SUCCESS",
                 output: {messageId: "msg_1a2b", sentAt: "2026-07-14 09:12"}},
            ],
        },
        {
            id: "exec_102", status: "FAILED", startedAt: "2026-07-14 08:03", durationMs: 410,
            trigger: {label: "Arbox — לקוח חדש", data: {"arbox.email": "", "arbox.first_name": "יוסי"}},
            steps: [
                {label: "צור מתאמן", kind: "CREATE_TRAINEE", status: "FAILED",
                 error: "אימייל חסר — לא ניתן ליצור מתאמן ללא אימייל"},
                {label: "עיבוד נתונים (מיזוג שם)", kind: "DATA_TRANSFORM", status: "SKIPPED"},
                {label: "שלח אימייל", kind: "EMAIL", status: "SKIPPED"},
            ],
        },
        {
            id: "exec_103", status: "SUCCESS", startedAt: "2026-07-13 22:47", durationMs: 910,
            trigger: {label: "Arbox — לקוח חדש", data: {"arbox.email": "avi@example.com", "arbox.first_name": "אבי", "arbox.last_name": "לוי"}},
            steps: [
                {label: "צור מתאמן", kind: "CREATE_TRAINEE", status: "SUCCESS",
                 output: {traineeId: 8124, userId: 45012, name: "אבי לוי", email: "avi@example.com", username: "avi@example.com", password: "Kp3mNq9s"}},
                {label: "עיבוד נתונים (מיזוג שם)", kind: "DATA_TRANSFORM", status: "SUCCESS", output: {result: "אבי לוי"}},
                {label: "שלח אימייל", kind: "EMAIL", status: "SUCCESS", output: {messageId: "msg_3c4d", sentAt: "2026-07-13 22:47"}},
            ],
        },
    ],
    auto_2: [
        {
            id: "exec_201", status: "SUCCESS", startedAt: "2026-07-13 18:40", durationMs: 520,
            trigger: {label: "משתמש נמחק", data: {"data.name": "רון בר", "data.email": "ron@example.com"}},
            steps: [
                {label: "מחק מתאמן", kind: "DELETE_TRAINEE", status: "SUCCESS",
                 output: {traineeId: 7011, email: "ron@example.com", name: "רון בר"}},
                {label: "שלח אימייל", kind: "EMAIL", status: "SUCCESS", output: {messageId: "msg_9z8y", sentAt: "2026-07-13 18:40"}},
            ],
        },
    ],
    auto_3: [],
};

export const STATUS_META = {
    SUCCESS: {label: "הצליח", color: "#10B981", bg: "#DCFCE7"},
    FAILED: {label: "נכשל", color: "#EF4444", bg: "#FEE2E2"},
    SKIPPED: {label: "דולג", color: "#94A3B8", bg: "#F1F5F9"},
    RUNNING: {label: "רץ", color: "#F59E0B", bg: "#FEF3C7"},
};

// ── Discovery: what's possible ───────────────────────────────────────────────
// Integration highlights (logos live in assets; iconType maps in the page).
export const INTEGRATIONS = [
    {id: "ARBOX", label: "Arbox", iconType: "arbox", blurb: "סנכרן לקוחות מ-Arbox אוטומטית"},
    {id: "FIREBERRY", label: "Fireberry", iconType: "fireberry", blurb: "חבר את ה-CRM שלך"},
    {id: "WEBHOOK", label: "Webhook", iconType: "webhook", blurb: "קבל אירועים מכל מערכת"},
    {id: "EMAIL", label: "אימייל מותאם", iconType: "email", blurb: "שלח מיילים עם תבנית עשירה"},
];

// Ready-made recipes. `flow` is the machine-readable definition the builder seeds from: a triggerKind
// (+ eventType for internal events) and an ordered list of action nodes. Each action entry is either:
//   - a string kind                              → chained, no pre-filled mapping
//   - {kind, mapping?, options?, id?}            → chained, WITH pre-filled field mappings/options
//   - {dataTransform:{outputName, expression}, id}  → a DATA_TRANSFORM node (e.g. build a full name)
//   - an array of any of the above              → a PARALLEL fan-out off the previous node
// mapping values use the builder shape {type:"FIELD"|"STATIC"|"HTML", value}. Templates pre-wire the
// {{arbox.*}}/{{trainee.*}} field mappings (same for every company); ids the user must PICK are left blank.
//
// `id` lets a later node reference an earlier one's output, e.g. {{createTrainee.traineeId}} — the id
// becomes the node's builder id so the token resolves.
const F = (value) => ({type: "FIELD", value});       // map from an upstream field
const S = (value) => ({type: "STATIC", value});      // a fixed value / interpolated literal
const HTML = (value) => ({type: "HTML", value});     // rich-text (email body)

export const TEMPLATES = [
    {
        id: "tmpl_arbox_create",
        title: "לקוח חדש ב-Arbox → צור מתאמן",
        blurb: "כשנרשם לקוח חדש ב-Arbox, ניצור לו מתאמן במערכת — עם כל השדות ממופים מראש",
        badge: "Arbox", accent: "arbox",
        steps: ["Arbox — לקוח חדש", "צור מתאמן"],
        flow: {
            triggerKind: "ARBOX_NEW_CLIENT",
            actions: [
                {dataTransform: {outputName: "full_name", expression: '{{arbox.first_name}} + " " + {{arbox.last_name}}'}, id: "fullname"},
                {kind: "CREATE_TRAINEE", id: "createTrainee", mapping: {
                    name: F("fullname.full_name"),
                    email: F("arbox.email"),
                    phoneNumber: F("arbox.phone"),
                    gender: F("arbox.gender"),
                    externalId: F("arbox.user_id"),
                }},
            ],
        },
    },
    {
        id: "tmpl_arbox_onboard",
        title: "לקוח חדש ב-Arbox → צור מתאמן → תוכנית + תפריט + טופס",
        blurb: "אונבורדינג מלא: יצירת מתאמן, ובמקביל שיוך תוכנית אימון, תפריט תזונה וטופס בריאות",
        badge: "Arbox", accent: "arbox",
        steps: ["Arbox — לקוח חדש", "צור מתאמן", "תוכנית + תפריט + טופס (במקביל)"],
        flow: {
            triggerKind: "ARBOX_NEW_CLIENT",
            actions: [
                {dataTransform: {outputName: "full_name", expression: '{{arbox.first_name}} + " " + {{arbox.last_name}}'}, id: "fullname"},
                {kind: "CREATE_TRAINEE", id: "createTrainee", mapping: {
                    name: F("fullname.full_name"),
                    email: F("arbox.email"),
                    phoneNumber: F("arbox.phone"),
                    gender: F("arbox.gender"),
                    externalId: F("arbox.user_id"),
                }},
                // Fan out: program + nutrition + form, each on the created trainee. templateId/menuId/
                // formTemplateId are left BLANK — the user picks the company's items from the dropdowns.
                [
                    {kind: "ASSIGN_PROGRAM_TEMPLATE", mapping: {traineeId: F("createTrainee.traineeId")}},
                    {kind: "ASSIGN_NUTRITION_MENU", mapping: {traineeId: F("createTrainee.traineeId")}},
                    {kind: "SEND_FORM", mapping: {traineeId: F("createTrainee.traineeId")}},
                ],
            ],
        },
    },
    {
        id: "tmpl_arbox_disabled",
        title: "לקוח הושבת ב-Arbox → השבת מתאמן",
        blurb: "כשלקוח מושבת/מוקפא ב-Arbox, נמצא את המתאמן לפי האימייל ונשבית אותו במערכת",
        badge: "Arbox", accent: "arbox",
        steps: ["Arbox — לקוח הושבת", "עדכן מתאמן (השבת)"],
        flow: {
            triggerKind: "ARBOX_CLIENT_DISABLED",
            actions: [
                {kind: "UPDATE_TRAINEE", id: "updateTrainee",
                    mapping: {matchValue: F("arbox.email"), enabled: S("false")},
                    options: {matchField: "EMAIL"}},
            ],
        },
    },
    {
        id: "tmpl_arbox_expiration",
        title: "תוקף מנוי עודכן ב-Arbox → עדכן תאריך תפוגה",
        blurb: "כשתאריך סיום המנוי משתנה ב-Arbox, נמצא את המתאמן לפי האימייל ונעדכן לו את תאריך התפוגה",
        badge: "Arbox", accent: "arbox",
        steps: ["Arbox — תוקף מנוי עודכן", "עדכן מתאמן (תאריך תפוגה)"],
        flow: {
            triggerKind: "ARBOX_CLIENT_EXPIRATION",
            actions: [
                {kind: "UPDATE_TRAINEE", id: "updateTrainee",
                    mapping: {matchValue: F("arbox.email"), expirationDate: F("arbox.membership_end_date")},
                    options: {matchField: "EMAIL"}},
            ],
        },
    },
    {
        id: "tmpl_progress_welcome",
        title: "מתאמן חדש ב-Progress → מייל ברוכים הבאים",
        blurb: "כשנוצר מתאמן חדש במערכת, נשלח לו מייל ברוכים הבאים עם פרטי הכניסה",
        badge: "Progress", accent: "progress",
        steps: ["מתאמן נוצר", "שלח אימייל"],
        flow: {
            triggerKind: "INTERNAL_EVENT", eventType: "USER_CREATED",
            actions: [
                {kind: "EMAIL", mapping: {
                    to: F("trainee.email"),
                    subject: S("ברוכים הבאים ל-Progress!"),
                    body: HTML('שלום {{trainee.name}},<br/><br/>נרשמת בהצלחה. שם המשתמש שלך: {{trainee.username}}.<br/><br/>נתראה באימון!'),
                }},
            ],
        },
    },
    {
        id: "tmpl_blank",
        title: "התחל מאפס",
        blurb: "בנה זרימה משלך — בחר טריגר וחבר פעולות",
        badge: null, accent: "blank", blank: true,
        steps: [],
        flow: null,
    },
];

export const templateById = (id) => TEMPLATES.find(x => x.id === id);
